import { Component, OnInit, Input, OnChanges, ElementRef, ViewChild, TemplateRef, AfterViewInit } from '@angular/core';
import { LoaderType } from 'src/app/shared/enums/common';
declare var initBodyCustomScroll: any;
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input() showLoader = false;
  @Input() size: number = 50;
  @Input() loaderType: string = LoaderType.circle;// default loader is circle
  @Input('class') public class: string = '';

  constructor(private _elementRef: ElementRef) { }
}
